import React from "react";

const Empty = ({ children, className = "", ...rest }) => (
  <div className={`empty${className ? " " + className : ""}`} {...rest}>
    {children}
  </div>
);

export default Empty;
